const deviceTranslation = {
  mode: 'ko',
  menu: '마미박스',
  listMenu: '마미박스 관리',
  versionMenu: '마미박스 버전 관리',
  agentVersionMenu: '에이전트 버전 관리',

  searchDevice: '장비 검색',
  editDeviceDetail: '번 마미박스 정보 수정',
  editDevice: '마미박스 수정',
  addDevice: '마미박스 추가',
  batchAddDevice: '마미박스 일괄 추가',

  // 일괄 추가 관련
  batchAdd: '일괄 추가',
  downloadTemplate: '샘플 파일 다운로드',
  uploadExcelFile: '엑셀 파일 업로드',
  dataValidation: '데이터 검증',
  validationInProgress: '데이터베이스와 중복 검사를 진행중입니다...',
  validationComplete: '검증 완료',

  // 오류 메시지
  requiredFieldError: '필수 항목입니다',
  duplicateInFileError: '중복된 디바이스명입니다 (파일 내)',
  duplicateInDatabaseError: '이미 등록된 디바이스명입니다 (DB)',

  // 통계 메시지
  validationSummary: '총 {{total}}개 데이터 중 {{valid}}개 등록 가능, {{invalid}}개 오류',
  duplicateStatistics: '파일 내 중복: {{file}}개, DB 중복: {{database}}개, 기타 오류: {{other}}개',

  // 배치 추가 모달 관련
  uploadFileDescription: '엑셀 파일을 업로드하세요',
  uploadDataDescription: '업로드된 데이터를 확인하세요',
  hospitalRoomSelectionDescription: '장비를 등록할 병원과 병실을 선택하세요',
  downloadTemplateDescription: '아래 버튼을 클릭하여 샘플 엑셀 파일을 다운로드하세요.',
  uploadFileInfo: '데이터를 입력한 엑셀 파일을 업로드하세요.',
  fileSizeLimit: '파일 크기는 10MB를 초과할 수 없습니다.',
  rowLimit: '최대 {{max}}행까지만 처리할 수 있습니다. 현재 파일: {{current}}행',
  fileParsingError: '파일을 읽는 중 오류가 발생했습니다. 파일 형식을 확인해주세요.',
  fileTypeError: 'Excel 파일(.xlsx, .xls)만 업로드할 수 있습니다.',
  validationCompleteStatus: '{{count}}개의 장비가 등록 준비되었습니다.',
  hospitalRoomSelectionInfo: '장비를 등록할 병원과 병실을 선택하세요.',
  selectHospital: '병원을 선택하세요',
  selectRoom: '병실을 선택하세요',
  hospitalSelection: '병원 선택',
  roomSelection: '병실 선택',
  registrationReady: '등록 가능',
  registrationNotPossible: '등록 불가',
  errorMessage: '오류 메시지',
  index: '번호',
  previous: '이전',
  next: '다음',
  validationInProgressStatus: '검증 중...',
  batchRegistration: '{{count}}개 장비 등록',
  partialSuccess: '{{success}}개 등록 성공, {{failure}}개 실패',
  failureItems: '실패 항목: {{items}}',
  registrationSuccess: '{{count}}개의 장비가 모두 등록되었습니다.',
  batchRegistrationFailed: '일괄 등록에 실패했습니다.',
  registrationError: '장비 등록 중 오류가 발생했습니다.',
  addDeviceVersion: '마미박스 버전 추가',
  recordingSetting: '녹화 설정',
  deviceSetting: '주변 장치 설정',
  functionSetting: '기능 설정',
  captureSwitchSetting: '캡쳐 스위치 설정',
  recordingScreenSetting: '녹화 화면 설정',
  autoUpdateSetting: '자동 업데이트 설정',
  advancedSetting: '고급 설정',
  developerSetting: '개발자 모드 설정',
  captureSetting: '캡쳐 및 녹화 관련 설정',
  info: '기본 정보',
  hospitalInfo: '병원 정보',
  sysInfo: '장비 데이터 수집 목록',
  sysInfoDescription: '장비가 온라인 상태일 때만 설정이 가능합니다.',

  hospitalLabel: '설치 병원',
  hospitalRoomLabel: '설치 진료실',
  maxRecordingTimeLabel: '최대 녹화 시간',
  motionThresholdLabel: '모션 감지 감도',
  recordingCardSelectModeLabel: '녹음 장치 선택',
  captureSoundLabel: '캡쳐 비프 음량',
  captureOnRecordingLabel: '녹화 중 캡쳐 가능 여부',
  pauseResumeLabel: '녹화재개/일시정지 소리 ON/OFF',
  diaryCaptureLabel: '산모수첩 캡쳐 사용',
  checkInvalidBarcodeLabel: '바코드 유효성 검사',
  checkInvalidBarcodeDescription:
    '1년 이상 지난 바코드 차단과 핑크바코드 차단을 한 번에 켜고 끄는 설정입니다. 단, 1년 이상 지난 바코드 차단 또는 핑크바코드 차단 중 하나라도 [-1]이 아닌 값으로 개별 설정하면 이 설정은 무시되고 개별 설정이 우선 적용됩니다. 개별 차단 설정은 서버에 저장되어도 장비 빌드 304 이상에서만 실제로 작동합니다.',
  checkExpiredBarcodeLabel: '1년 이상 지난 바코드 차단',
  checkPinkBarcodeLabel: '핑크바코드 차단',
  checkPinkBarcodeDescription:
    '빌드 313 이상 장비에서 핑크바코드 차단을 사용하면, 녹화 이력과 관계없이 핑크바코드 발급 목록에 포함된 모든 바코드를 차단합니다. 단, 차단 예외 목록에 등록된 바코드는 핑크바코드 차단에서 제외됩니다.',
  checkPinkBarcodePeriodLabel: '핑크바코드 기간 차단',
  checkPinkBarcodePeriodDescription:
    '최초 녹화일부터 설정한 기간이 지난 핑크바코드의 녹화 시작을 차단합니다. 빌드 312 이상 장비부터 지원 예정이며, 빌드 311 이하에서는 이 설정이 적용되지 않습니다. 핑크바코드 차단을 함께 켜면 기간과 관계없이 즉시 차단됩니다.',
  pinkBarcodeValidDaysLabel: '핑크바코드 사용 가능 기간(일)',
  pinkBarcodeValidDaysDescription:
    '기본값은 60일입니다. 최초 등록일은 유지되며 기간을 바꾸면 기존 사용자도 다음 스캔부터 적용됩니다. 기간 차단을 꺼도 설정한 기간은 유지됩니다.',
  pinkBarcodeValidDaysValidation: '사용 가능 기간은 1 이상의 정수로 입력해 주세요.',
  motionTimeoutLabel: '모션 감지 타임아웃',
  checkScreensaverLabel: '화면보호기 모드 감지',
  imageQualityCheckLabel: '녹화 중 이미지 품질 체크',
  recordingMediaValidationLabel: '녹화 종료 후 영상·음성 품질 검사',
  recordingMediaValidationDescription:
    '2.11.310 이상에서 녹화 종료 후 무음·영상 이상을 검사해 알림을 남깁니다. 저장 후 재시작 없이 적용되며, 이미 시작한 검사는 완료됩니다.',
  recordingMediaValidationDisabledOption: '[0] 사용하지 않는다',
  recordingMediaValidationEnabledOption: '[1] 사용한다 (기본값)',
  recordingVideoFreezeThresholdLabel: '정지 화면 감지 기준 (초)',
  recordingVideoFreezeThresholdDescription:
    '기본 600초(10분). 화면이 연속으로 이 시간 이상 멈추면 알립니다. 품질 검사가 켜져 있을 때 사용하며, 변경값은 다음 파일 검사부터 적용됩니다. 이 설정을 지원하는 장비 앱 업데이트가 필요합니다.',
  checkOnlineLabel: '네트워크 상태 감지',
  autoUpdateLabel: '자동 업데이트 여부',
  updateTargetLabel: '자동 업데이트 대상 버전',
  notificationFeedbackLabel: '이상 감지 자동 음성 알림 활성화',
  notificationFeedbackDescription:
    '기본값은 사용하지 않음입니다. 사용 시 파일 증가가 장시간 정체되면 녹화 불가 안내 음성과 LED 경고를 보냅니다. 감지·반복 간격은 파일 체크 간격과 오류 실패 횟수 설정에 따라 달라지며, 정체가 지속되면 반복 알림을 보냅니다. 이 알림 자체로 녹화를 종료하지는 않습니다.',
  notificationFeedbackScopeDescription:
    '현재 2.11.310 기준으로 모든 이상에 음성이 재생되는 것은 아닙니다. 수동 음성 안내는 이 설정과 무관하게 동작합니다.',
  build299Required: '빌드 308부터 사용가능',
  printerLabel: '프린터 사용(CP1300)',
  recordingBrightnessLabel: '녹화 밝기',
  recordingContrastLabel: '녹화 대비',
  debugModeLabel: '디버그 모드 활성화',
  vsyncLabel: '비디오 타임스탬프 동기화 설정',
  thresholdLuminanceLabel: '모션 감지 밝기 임계값',
  maxConsecutiveImageIssuesLabel: '문제된 이미지 허용 횟수',
  colorImbalanceThresholdLabel: '색상 불균형 임계값',
  fileMinGrowthRateLabel: '파일 최소 증가율 (bytes/sec)',
  fileGrowthLearningEnabledLabel: '파일 증가율 학습 기능 활성화',
  fileCheckIntervalLabel: '파일 체크 시간 간격 (초)',
  fileMaxFailureLabel: '파일 체크 최대 실패 횟수',
  fileMaxFailureForErrorLabel: '파일 체크 오류 실패 횟수',
  VideoMinDurationRatioLabel: '비디오 길이 체크 비율',

  devicePlaceHolder: '장비명 입력',
  descriptionPlaceHolder: '장비 설명 입력',
  hospitalRoomPlaceHolder: '진료실 선택',
  buildNumberPlaceHolder: '빌드 번호 입력',
  buildHashPlaceHolder: '빌드 해시 입력',
  versionNamePlaceHolder: '버전 이름 입력',
  versionDescriptionPlaceHolder: '버전 설명 입력',
  customInputPlaceholder: '직접 입력',

  seq: '번호',
  name: '장비명',
  deviceName: '장비명(기번)',
  hospital: '설치병원',
  version: '마미박스 버전',
  agentVersion: '에이전트 버전',
  hospitalRoom: '설치진료실',
  activity: '마지막활동',
  motionThreshold: '모션감도',
  maxRecordingTime: '최대녹화시간',
  minute: '분',
  printer: '프린터',
  capture: '캡쳐기능',
  captureSwitch: '캡쳐스위치모드',
  recordingBrightness: '녹화밝기',
  recordingContrast: '녹화대비',
  recordingCardSelectMode: '녹음장치',
  captureOnRecording: '녹화중에만캡쳐',
  checkInvalidBarcode: '바코드유효성검사',
  checkScreensaver: '화면보호기감지',
  activeFlag: '활성상태',
  active: '활성화',
  inactive: '비활성화',
  activeDevice: '활성 마미박스',
  inactiveDevice: '비활성 마미박스',
  installFlag: '설치여부',
  install: '설치',
  installDevice: '설치된 마미박스',
  uninstallDevice: '미설치된 마미박스',
  description: '장비 설명',
  record: '기록',
  detailRecord: '상세 기록',
  uptime: '장비 가동시간',
  timeZone: '시간대',

  vfr: 'vfr',
  cfr: 'cfr',
  main: 'Main',
  beta: 'Beta',
  custom: '직접 입력',

  motionThreshold001: '[0.010] 매우 예민하게',
  motionThreshold005: '[0.050] 예민하게',
  motionThreshold018: '[0.180] 보통 (기본값)',
  motionThreshold022: '[0.220] 둔감하게',
  motionThreshold999: '[999.999] 모션감지 사용 안함',
  captureSwitchNone: '캡쳐 + 캡쳐',
  captureSwitchCs: '캡쳐 + 녹화시작_녹화종료',
  captureSwitchCp: '캡쳐 + 녹화재개_일시정지',
  captureSwitchSp: '녹화시작_녹화종료 + 녹화재개_일시정지',
  captureSwitchPs: '녹화재개_일시정지 + 녹화시작_녹화종료',
  recordingCardSelectModeDefault: '마미박스가 알아서 선택',
  recordingCardSelectModeYuh01: '신캡 3.5mm',
  recordingCardSelectModeEzcap: '게임독 울트라 3.5mm',
  recordingCardSelectModeAlc255: 'PN40 전면부 입력',
  recordingCardSelectModeUsb: 'USB 입력창지(0d8c:0014)',
  recordingCardSelectModeAv: '이지캡 (534d:0021)',

  buildNumber: '빌드 번호',
  buildHash: '빌드 해시',
  versionName: '버전 이름',
  versionDescription: '버전 설명',
  visibleFlag: '표시 여부',
  autoUpdateFlag: '자동 업데이트 여부',
  createdAt: '생성일시',
  updatedAt: '수정일시',

  assignedRoom: '배정된 진료실 있음',
  unassignedRoom: '배정된 진료실 없음',
  activeDeviceMessage: '를 활성화하시겠습니까?',
  inactiveDeviceMessage: '를 비활성화하시겠습니까?',
  inactiveDeviceWarningMessage: '* 비활성화된 박스는 종합모니터링에 표시되지 않습니다.',
  descriptionMessage: '* 보통 진료실명을 입력합니다.',
  inactiveMessage: '* 0으로 설정하면 비활성화됩니다.',
  developerSettingWarningTitle: '고급 설정 접근 경고',
  developerSettingWarningMessage: '고급 설정은 개발자 외의 사용자에게는 권장하지 않습니다.',
  saveVerificationSuccess: '저장 후 서버 반영까지 확인했습니다.',
  saveVerificationFailedTitle: '서버 반영 확인 실패',
  saveVerificationMismatchDescription: '저장 후 재조회 결과 아래 항목의 값이 다릅니다.',
  saveVerificationMismatchItem: '{{field}}: 요청값 {{expected}} / 서버값 {{actual}}',
  saveVerificationDeviceNotFound: '저장 후 재조회 결과 대상 장비를 찾지 못했습니다.',
  saveVerificationTargetMissing:
    '검증에 필요한 병원 정보가 없어 서버 반영 여부를 확인할 수 없습니다.',
  saveVerificationQueryFailed:
    '저장 후 서버 반영 확인 중 오류가 발생했습니다. 모달은 열린 상태로 유지됩니다.',
  saveVerificationUpdateFailed: '장비 설정 저장에 실패했습니다.',
  deviceReflectMessage1: '* 빌드 248부터 사용 가능',
  deviceReflectMessage2: '* 빌드 251부터 사용 가능',
  deviceReflectMessage3: '* 빌드 252부터 사용 가능',
  deviceReflectMessage4: '* 빌드 253부터 사용 가능',
  deviceReflectMessage5: '* 빌드 257부터 사용 가능',
  deviceReflectMessage6: '* 빌드 283부터 사용 가능',
  deviceReflectMessage7: '* 빌드 251부터 저장 후 마미박스에 즉시 반영됩니다.',
  deviceReflectMessage8: '* 빌드 291부터 사용 가능',
  deviceReflectMessage9: '* 빌드 295부터 사용 가능',
  deviceReflectMessage10: '* 빌드 298부터 사용 가능',
  deviceReflectMessage11:
    '* 빌드 304 이상 장비에서만 실제 동작합니다. 빌드 303 이하 장비는 바코드 유효성 검사 설정을 따릅니다.',
  motionTimeoutMessage: '* 0에서 60 사이의 값 입력',
  thresholdLuminanceMessage: '* 0에서 100 사이의 값 입력',
  maxConsecutiveImageIssuesMessage: '* 1에서 30 사이의 값 입력',
  colorImbalanceThresholdMessage: '* 0에서 100.0 사이의 값 입력',
  fileMinGrowthRateMessage: '* 1000에서 1000000 사이의 값 입력',
  fileCheckIntervalMessage: '* 3에서 60 사이의 값 입력',
  fileMaxFailuresMessage: '* 1에서 12 사이의 값 입력',
  fileMaxFailuresForErrorMessage: '* 1에서 120 사이의 값 입력',
  videoMinDurationRatioMessage: '* 0.1에서 0.9 사이의 값 입력',
  recordingCardSelectModeDefaultOption: '마미박스가 알아서 선택하게 함 (기본값)',
  recordingCardSelectModeYuh01Option: '신캡 3.5mm 입력 (YUH01/TC-UB570)',
  recordingCardSelectModeEzcapOption: '게임독 울트라 3.5mm 입력 (ezcap GameDock Ultra)',
  recordingCardSelectModeAlc255Option: '[PN40 전용] 전면부 입력, y잭 (ALC255 Analog)',
  recordingCardSelectModeUsbOption: '범용 USB 입력장치(마이크) (0d8c:0014)',
  recordingCardSelectModeAvOption: '이지캡 (534d:0021)',
  captureSwitchNoneOption: '[none] 캡쳐 + 캡쳐 (기본값)',
  captureSwitchCsOption: '[cs] 캡쳐 + 녹화시작_녹화종료',
  captureSwitchCpOption: '[cp] 캡쳐 + 녹화재개_일시정지',
  captureSwitchSpOption: '[sp] 녹화시작_녹화종료 + 녹화재개_일시정지',
  captureSwitchPsOption: '[ps] 녹화재개_일시정지 + 녹화시작_녹화종료',
  optionMessage1: '[0] 사용하지 않는다 (기본값)',
  optionMessage2: '[1] 사용한다',
  barcodeCheckModeInheritOption: '[-1] 바코드 유효성 검사 설정 따름',
  barcodeCheckModeDisableOption: '[0] 사용하지 않는다',
  barcodeCheckModeEnableOption: '[1] 사용한다',
  checkScreensaverOption1: '[0] 사용하지 않는다',
  checkScreensaverOption2: '[1] 사용한다 (기본값)',
  captureSoundOption1: '[1] 작게',
  captureSoundOption2: '[3] 보통 (기본값)',
  captureSoundOption3: '[5] 크게',
  captureOnRecordingOption1: '[0] 언제든 캡쳐',
  captureOnRecordingOption2: '[1] 녹화 중에만 캡쳐',
  pauseResumeOption1: '[0] 켠다 (기본값)',
  pauseResumeOption2: '[1] 끈다',
  recordingBrightnessOption1: '[-0.10] 10% 어둡게',
  recordingBrightnessOption2: '[-0.08] 8% 어둡게',
  recordingBrightnessOption3: '[-0.06] 6% 어둡게',
  recordingBrightnessOption4: '[-0.04] 4% 어둡게',
  recordingBrightnessOption5: '[-0.02] 2% 어둡게',
  recordingBrightnessOption6: '[0.00] 0% (기본값)',
  recordingBrightnessOption7: '[0.02] 2% 밝게',
  recordingBrightnessOption8: '[0.04] 4% 밝게',
  recordingBrightnessOption9: '[0.06] 6% 밝게',
  recordingBrightnessOption10: '[0.08] 8% 밝게',
  recordingBrightnessOption11: '[0.10] 10% 밝게',
  recordingContrastOption1: '[0.98] -2% 대비',
  recordingContrastOption2: '[1.00] 0% 대비',
  recordingContrastOption3: '[1.01] 1% 대비',
  recordingContrastOption4: '[1.02] 2% 대비',
  recordingContrastOption5: '[1.03] 3% 대비',
  recordingContrastOption6: '[1.05] 5% 대비',
  recordingContrastOption7: '[1.07] 7% 대비 (기본값)',
  deviceActiveOption1: '[1] 활성',
  deviceActiveOption2: '[0] 비활성',
  deviceInstallOption1: '[1] 설치',
  deviceInstallOption2: '[0] 미설치',

  versionFixFlag: '버전 고정 선택',
  versionFix: '마미박스 v3',
  agentVersionFix: '에이전트 v3',
  agentVersionFixTrue: '[1] 고정',
  agentVersionFixFalse: '[0] 미고정',
  mommyboxVersionFixTrue: '[1] 고정',
  mommyboxVersionFixFalse: '[0] 미고정',
  versionFixDescription: '버전 고정 상태에서는 자동 업데이트가 불가능합니다.',

  inactiveKeepHospital: '병원/병실 유지',
  inactiveMoveToInactiveRoom: '비활성 병실로 이동',
  inactiveDeleteHospital: '병원/병실 삭제',

  // 비활성화 모달 관련
  inactiveModalTitle: '비활성화',
  roomProcessingMethod: '병실 처리 방식',
  additionalOptions: '추가 옵션',
  currentRoomMaintain: '현재 병실을 유지합니다',
  moveToInactiveRoom: '비활성 병실로 이동',
  moveToInactiveRoomDesc: '지정된 비활성화 병원/병실로 이동합니다',
  moveToSpecificRoom: '병원/병실 이동',
  moveToSpecificRoomDesc: '선택한 병원/병실로 이동합니다',
  removeFromHospital: '병원에서 완전히 제거합니다',
  resetSettings: '설정값 초기화',
  resetSettingsDesc: '모든 cfg1_ 설정값을 기본값으로 초기화합니다',
  changeDescription: '설명 변경',
  changeDescriptionPlaceholder: '설명을 선택하거나 직접 입력하세요',
  changeDescriptionDesc: '기본 옵션을 선택하거나 직접 입력할 수 있습니다',
  selectHospitalAndRoom: '이동할 병원 및 병실 선택',
  selectHospitalPlaceholder: '병원을 선택하세요',
  selectRoomPlaceholder: '병실을 선택하세요',
  selectHospitalFirst: '먼저 병원을 선택해주세요',
  noRoomsAvailable: '선택한 병원에는 등록된 병실이 없습니다',
  noRoomOption: '병실없음',
  deviceInfo: '장비명:',
  hospitalInfoLabel: '병원:',
  currentRoom: '현재 병실:',
  currentDescription: '현재 설명:',
  unspecified: '미지정',
  none: '없음',
  lost: '분실',
  hospitalRoomLoadingInfo: '병원 정보 로딩 중...',
  missingHospitalInfo: '병원 정보 없음',
  missingRoomInfo: '병실 정보 없음',
};

export default deviceTranslation;
